import firebase from "firebase/compat/app";

export function createSamlProvider(providerId: string) {
  return new firebase.auth.SAMLAuthProvider(providerId);
}
